import { UseQueryOptions } from 'react-query';
import { VoicemailConfigAPI } from '@frontend/api-voicemail-boxes';
import { useQuery } from '@frontend/react-query-helpers';
import { SchemaIO } from '@frontend/schema';
import { queryKeys } from '../../query-keys';

type VoicemailBoxListResponse = SchemaIO<(typeof VoicemailConfigAPI)['List']>['output'];

const useVoicemailBoxes = ({
  phoneTenantId,
  options = {},
}: {
  phoneTenantId: string;
  options?: UseQueryOptions<VoicemailBoxListResponse, unknown, VoicemailBoxListResponse['voicemailBoxes']>;
}) => {
  return useQuery({
    queryKey: [phoneTenantId, ...queryKeys.settings.listVoicemailBox()],
    queryFn: () => VoicemailConfigAPI.List({ tenantId: phoneTenantId }),
    select: ({ voicemailBoxes }) => voicemailBoxes.sort((a, b) => a.mailbox.name.localeCompare(b.mailbox.name)),
    enabled: !!phoneTenantId,
    staleTime: 5 * 60 * 1000,
    meta: {
      error: {
        message: 'useVoicemailBoxes:query | Failed to fetch voicemail boxes',
        data: { phoneTenantId },
      },
    },
    ...options,
  });
};

export default useVoicemailBoxes;
